import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  bold: {
    fontWeight: 'bold',
    color: theme.font.defaultColor,
  },
  title: {
    fontWeight: 'bold',
    fontSize: theme.font.mediumSize,
    color: theme.font.titleColor,
  },
  normal: {
    color: theme.font.defaultColor,
  },
  small: {
    fontSize: theme.font.smallSize,
    color: theme.font.defaultColor,
  },
  subtitle: {
    fontSize: theme.font.smallSize,
    color: theme.font.subtitleColor,
  },
  primary: {
    color: theme.palette.primaryPure,
  },
  'primary-bold': {
    fontWeight: 'bold',
    color: theme.palette.primaryPure,
    textRendering: 'geometricPrecision',
  },
  smallWhite: {
    color: 'white',
    fontSize: theme.font.smallSize,
  },
  secondary: {
    fontSize: theme.font.smallSize,
    color: theme.palette.secondaryPure,
    opacity: '0.5',
  },
  secondaryPure: {
    fontSize: theme.font.smallSize,
    color: theme.palette.secondaryPure,
  },
  secondaryMedium: {
    color: theme.palette.secondaryPure,
    opacity: '0.5',
  },
  secondaryLink: {
    color: theme.palette.secondaryPure,
    opacity: '0.5',
    textDecoration: 'underline',
  },
  disabled: {
    color: theme.palette.secondaryPure,
    opacity: '0.5',
  },
}));

export default useStyles;
